<div class="talker-padding-wrapper" #parentWrapper>
  <div class="sticky-breadcrumbs in-padding-wrapper-full-width" *ngIf="organization">
    <app-breadcrumb [breadcrumbInputs]="(breadcrumbs$ | async) || []" (urlClicked)="goToOrganization($event)"></app-breadcrumb>
    <div
      class="organization-offer-banner-shell in-padding-wrapper-full-width"
      [class.is-scrolled]="isBannerScrolled"
      *ngIf="organization">
      <app-organization-offer-banner [organization]="organization"></app-organization-offer-banner>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
